import React, { useState, useEffect } from 'react';
import { isDataError, isDataLoaded } from '../../types/data-providers';
import { LocationCard } from '../LocationCard';
import * as _ from 'lodash';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { DataIndicators } from '../DataIndicators';
import { useSignalRData } from '../../data/DataProviders/SignalRDataProvider';
import { sortObjectArrayNaturally } from '../../lib';
import { DeviceCountProvider } from '../../data/DataProviders/DeviceCountProvider';
import { useLocationAlarmList } from '../../data/DataProviders/LocationListProvider';
import { SiteOnlineStatusDataProvider } from '../../data/DataProviders/SiteOnlineStatusDataProvider';
import { Footer } from '../Footer/Footer';

export const LocationCards: React.FC = () => {
    const { t } = useLanguageLocale();

    const locationList = useLocationAlarmList();
    const signalRData = useSignalRData();
    const [alarmCount, setAlarmCount] = useState(0);
    const isEmpty = isDataLoaded(locationList) && locationList.value.length === 0;
    const isErrorInfo = isEmpty || isDataError(locationList);

    useEffect(() => {
        if (isDataLoaded(locationList)) {
            _.filter(signalRData.locations, (location) => {
                _.filter(locationList.value, (exsitinglocation) => {
                    if (location.alarmCount && location.alarmCount  !== null) {
                    if (location.locationId === exsitinglocation.locationId && location.alarmCount !== null) {
                        exsitinglocation.alarmCount = location.alarmCount;
                        setAlarmCount(exsitinglocation.alarmCount);
                    }
                } 
                });
            });
        }
    }, [signalRData, alarmCount]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <DataIndicators
                errorMessage={t('DASHBOARD.ORGANIZATION')}
                emptyMessage={t('DASHBOARD.LOCATION')}
                data={locationList}
                emptyIcon="LocationCity"
                isEmpty={isEmpty}
                isDetailedInfo={isErrorInfo}
            />

            {isDataLoaded(locationList) && locationList.value.length > 1 && (
                <>
                    <div style={{ display: 'flex', flexWrap: 'wrap', paddingLeft: 48, paddingRight: 48 }}>
                        {sortObjectArrayNaturally(locationList.value, [
                            { sortField: 'alarmCount', sortOrder: 'DESC' },
                            { sortField: 'locationName' },
                        ]).map((location) => (
                            <DeviceCountProvider key={location.locationId} siteId={location.locationId}>
                              <SiteOnlineStatusDataProvider siteId={location.locationId}>
                                <LocationCard
                                    id={location.locationId}
                                    name={location.locationName}
                                    alarmCount={location.alarmCount}
                                    siteCount={location.siteCount}
                                />
                                </SiteOnlineStatusDataProvider>
                            </DeviceCountProvider>
                        ))}
                    </div>
                    <Footer text={t('DISCLAMIER.OVERVIEW')} />
                </>
            )}
        </>
    );
};
